<div class="d-flex align-items-center  p-2" *ngIf="HasHeader" style="background-color: #87858525;">
    <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14 collection-title"> {{'provaAcquisto.title' | translate}}:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </span>
  
    <button type="button" (click)="add()" class="ml-auto btn btn-cyan rounded-pill p-2" *ngIf="!permission.isOperativeRole('CA') && !isModifyDisabled && !environment.RmaAddOn['HidePAadd']">
      <i class="fas fa-plus  font-14 text-white"></i>
      <span class="ml-1 text-white font-weight-bold button-title">{{'provaAcquisto.add' | translate}}</span>
    </button>
</div>
<div class="card" *ngIf="HasFilter && !Local && !environment.RmaAddOn['FiltriProveAcquisto']">

  <div class="input-group mt-3">
    <div class="input-group-prepend">
      <span class="input-group-text">{{'RMA.product' | translate}}</span>
    </div>
    <div class="custom-file">
      <input type="text" [(ngModel)]="Filter.prodotto" (ngModelChange)="refresh()" class="form-control"  >
    </div>
  </div>
</div>
<div class="card" *ngIf="environment.RmaAddOn['FiltriProveAcquisto']">
    <app-field-viewer [Campi]="environment.RmaAddOn['FiltriProveAcquisto']" [(Oggetto)]="Filter" (OnChange)="refresh()" [DropdownSources]="DropdownSources"></app-field-viewer> 
</div>

<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead *ngIf="!environment.RmaAddOn['CampiProvaAcquisto'] && !Headers">
    <tr >
<!--      <th scope="col">Id</th>-->
      <th scope="col">{{'RMA.matricola' | translate}}</th>
      <th scope="col">{{'RMA.product' | translate}}</th>
      <th scope="col">{{'RMA.cliente.title' | translate}}</th>
      <th scope="col" *ngIf="!isModifyDisabled || Local">{{'RMA.Actions' | translate}}</th>
    </tr>
    </thead>
    <thead>
    <tr class="HorizontalHeader" *ngIf="environment.RmaAddOn['CampiProvaAcquisto'] && !Headers">
      <ng-container *ngFor="let campo of environment.RmaAddOn['CampiProvaAcquisto']">
        <th scope="col" *ngIf="permission.isntOperativeRoles(campo.prohibitedRoles) && permission.isOperativeRoles(campo.AllowedRoles) && campo.viewInList" >{{campo.nome | translate}}</th>
      </ng-container>
      <th scope="col" *ngIf="!isModifyDisabled || Local">Azioni</th>
    </tr>
    <tr class="VerticalHeader" *ngIf="environment.RmaAddOn['CampiProvaAcquisto'] && !Headers">
      <th scope="col" class="font-14" >{{'provaAcquisto.title' | translate}} </th>
      <th scope="col" class="font-14" *ngIf="!isModifyDisabled || Local">Azioni</th>
    </tr>
    </thead>
    <thead>
    <tr *ngIf="Headers">
      <ng-container *ngFor="let campo of Headers">
        <th scope="col" *ngIf="permission.isntOperativeRoles(campo.prohibitedRoles) && permission.isOperativeRoles(campo.AllowedRoles)" >{{campo.nome}}</th>
      </ng-container>
      <th scope="col" *ngIf="!isModifyDisabled || Local">Azioni</th>
    </tr>
    </thead>
    <tbody *ngIf="!environment.RmaAddOn['CampiProvaAcquisto']" >
    <tr *ngFor="let co of List">
      <td>
        <span *ngIf="!co.modifica" class="text-dark font-medium font-16">
          {{co.seriale}}
        </span>
        <span *ngIf="co.modifica">
          <input [(ngModel)]="co.seriale" placeholder="{{'RMA.matricola'  | translate}}" type="text" name="voce" class="form-control">
        </span>

      </td>
<!--      <td>-->
<!--        <span  *ngIf="!co.modifica" class="text-dark font-medium font-16">-->
<!--          {{co.id}}-->
<!--        </span>-->

<!--      </td>-->
      <td>
        <span  *ngIf="!co.modifica" class="text-dark font-medium font-16">
          {{co.prodotto}}
        </span>
        <span *ngIf="co.modifica">
          <input [(ngModel)]="co.prodotto" placeholder="{{'RMA.product'  | translate}}" type="text" name="voce" class="form-control">
        </span>
      </td>

      <td>
        <span class="text-dark font-medium font-16" *ngIf="co?.sedeObject?.label">
          {{co.sedeObject.label}}
<!--          {{co.acquirente?.nominativo}} {{co.acquirente?.indirizzo}}&nbsp;-&nbsp;{{co.acquirente?.cap}}&nbsp;{{co.acquirente?.citta}}&nbsp;({{co.acquirente?.provincia}})-->
        </span>
        <span class="text-dark font-medium font-16" *ngIf="!co?.sedeObject?.label">
          {{co.acquirente?.nominativo}} {{co.acquirente?.indirizzo}}&nbsp;-&nbsp;{{co.acquirente?.cap}}&nbsp;{{co.acquirente?.citta}}&nbsp;({{co.acquirente?.provincia}})
        </span>

      </td>
      <td class="align-middle" *ngIf="!isModifyDisabled">
        <a href="javascript:void(0)" *ngIf="!Progetto &&!co.modifica" (click)="addRma(co)" [ngbTooltip]="'RMA.addTicket' | translate" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-plus-circle"></i>
          {{'RMA.addTicket' | translate}}
        </a>
        <a href="javascript:void(0)" *ngIf="Progetto && !co.modifica && !environment.RmaAddOn['HideRmaAdd']" (click)="addVerifica(co)" [ngbTooltip]="'RMA.addTicket' | translate" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-plus-circle"></i>
          {{'Aggiungi Attività'}}
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0)" *ngIf="!co.modifica" (click)="add(co)" ngbTooltip="edit" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="co.modifica " (click)="salva(co)" ngbTooltip="Save" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-check"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="!co.modifica " (click)="delete(co)" ngbTooltip="Delete" class="link font-16 text-danger font-medium mr-2">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
      <td class="align-middle" *ngIf="Local">
        <a href="javascript:void(0)" *ngIf="!co.modifica " (click)="deleteLocal(co)" ngbTooltip="Delete" class="link font-16 text-danger font-medium mr-2">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
    </tr>
    </tbody>
    <tbody *ngIf="environment.RmaAddOn['CampiProvaAcquisto'] && !Headers" >
    <tr *ngFor="let co of List" class="HorizontalItem">
      <ng-container *ngFor="let campo of environment.RmaAddOn['CampiProvaAcquisto']">
        <td class="align-middle" [ngClass]="campo.class" *ngIf="campo.viewInList">
          <app-list-campo-viewer [campo]="campo" [Oggetto]="co"></app-list-campo-viewer>
        </td>
      </ng-container>

      <td class="align-middle" *ngIf="!isModifyDisabled">
        <a href="javascript:void(0)" *ngIf="!Progetto &&!co.modifica" (click)="addRma(co)" [ngbTooltip]="'RMA.addTicket' | translate" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-plus-circle"></i>
          {{'RMA.addTicket' | translate}}
        </a>
        <a href="javascript:void(0)" *ngIf="Progetto && !co.modifica && !environment.RmaAddOn['HideRmaAdd']" (click)="addVerifica(co)" [ngbTooltip]="'RMA.addTicket' | translate" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-plus-circle"></i>
          {{'Aggiungi Attività'}}
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0)" *ngIf="!co.modifica" (click)="add(co)" ngbTooltip="edit" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="co.modifica " (click)="salva(co)" ngbTooltip="Save" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-check"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="!co.modifica " (click)="delete(co)" ngbTooltip="Delete" class="link font-16 text-danger font-medium mr-2">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
      <td class="align-middle" *ngIf="Local">
        <a href="javascript:void(0)" *ngIf="!co.modifica " (click)="deleteLocal(co)" ngbTooltip="Delete" class="link font-16 text-danger font-medium mr-2">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
    </tr>
    <tr *ngFor="let co of List" class="VerticalItem">
      <td class="align-middle"  >
        <div class="row">
        <ng-container *ngFor="let campo of environment.RmaAddOn['CampiProvaAcquisto']">
          
            <div class="col-12" *ngIf="campo.viewInList">
              <span class="font-16" style="font-weight: bold !important;">{{campo.nome}}: &nbsp;</span>
              <span class="font-16 "><app-list-campo-viewer [campo]="campo" [Oggetto]="co"></app-list-campo-viewer></span>
            </div>
          
        </ng-container>
      </div>
      </td>

      <td class="align-middle" *ngIf="!isModifyDisabled">
        <a href="javascript:void(0)" *ngIf="!Progetto &&!co.modifica" (click)="addRma(co)" [ngbTooltip]="'RMA.addTicket' | translate" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-plus-circle"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="Progetto && !co.modifica && !environment.RmaAddOn['HideRmaAdd']" (click)="addVerifica(co)" [ngbTooltip]="'RMA.addTicket' | translate" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-plus-circle"></i>
          {{'Aggiungi Attività'}}
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0)" *ngIf="!co.modifica" (click)="add(co)" ngbTooltip="edit" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="co.modifica " (click)="salva(co)" ngbTooltip="Save" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-check"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="!co.modifica " (click)="delete(co)" ngbTooltip="Delete" class="link font-16 text-danger font-medium mr-2">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
      <td class="align-middle" *ngIf="Local">
        <a href="javascript:void(0)" *ngIf="!co.modifica " (click)="deleteLocal(co)" ngbTooltip="Delete" class="link font-16 text-danger font-medium mr-2">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
    </tbody>
    <tbody *ngIf="Headers" >
    <tr *ngFor="let co of List">
      <ng-container *ngFor="let campo of Headers">
        <td class="align-middle" [ngClass]="campo.class">
          <app-list-campo-viewer [campo]="campo" [Oggetto]="co"></app-list-campo-viewer>
        </td>
      </ng-container>
      <td class="align-middle" *ngIf="!isModifyDisabled">
        <a href="javascript:void(0)" *ngIf="!Progetto &&!co.modifica" (click)="addRma(co)" [ngbTooltip]="'RMA.addTicket' | translate" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-plus-circle"></i>
          {{'RMA.addTicket' | translate}}
        </a>
        <a href="javascript:void(0)" *ngIf="Progetto && !co.modifica && !environment.RmaAddOn['HideRmaAdd']" (click)="addVerifica(co)" [ngbTooltip]="'RMA.addTicket' | translate" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-plus-circle"></i>
          {{'Aggiungi Attività'}}
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a href="javascript:void(0)" *ngIf="!co.modifica" (click)="add(co)" ngbTooltip="edit" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="co.modifica " (click)="salva(co)" ngbTooltip="Save" class="link font-16 text-info font-medium mr-2">
          <i class="fas fa-check"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="!co.modifica " (click)="delete(co)" ngbTooltip="Delete" class="link font-16 text-danger font-medium mr-2">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
      <td class="align-middle" *ngIf="Local">
        <a href="javascript:void(0)" *ngIf="!co.modifica " (click)="deleteLocal(co)" ngbTooltip="Delete" class="link font-16 text-danger font-medium mr-2">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>

